import React, { useEffect, useState } from "react";
import isLoggedIn from "../../utils/isLoggedIn";
import { getForgotPasswordCode } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import logo from "../../assets/img/humanely.png";


export default function ForgotPassword(props) {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        isLoggedIn() && props.history.push("/dashboard");
    }, [props]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const data = {
            email: e.target.email.value,
            path: "resetpassword",
        };        
        if(data.email){
            getForgotPasswordCode(data)
                .then((res) => {
                    if(res.data.success){         
                        alertSuccess(res.data.message);
                        setLoading(false);
                        props.history.push("/");
                    }
              })
              .catch((error) => {
                setLoading(false);
                alertError(error?.response?.data?.error);
              });
        }
    };

    return (
        <>      
            <section className="quotes" style={{padding:20, marginTop: 50}}>
                <div className="container">
                    
                    <div className="text-center">
                        <img src={logo} className="" alt="logo" width={"135px"}  style={{marginBottom: 20}} />
                    </div>
                    
                    <div className="account">
                        <h2 className="font-weight-bold">Recover Your Password</h2>

                        <form method="post" onSubmit={handleSubmit} >
                            <p className="font-weight-bold text-danger"> </p>
                            <div className="row">
                                <div className="form-group col-md-12">
                                    <label>Enter your Email</label>
                                    <input 
                                        type="email" 
                                        name="email" 
                                        required 
                                        placeholder="Enter your Email" 
                                        id="email" 
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <button type="submit"  className="btn btn-primary" 
                                        disabled={loading ? true : false}>
                                        {!loading ? "Submit" : <i className="fa fa-spinner fa-spin"></i>}
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div className="form_links">
                            <p>Have your login details? <a href="/">Login here</a></p>
                        </div>
                    </div>
                    
                    <p 
                        className="text-center mt-5" 
                        style={{fontSize:12, marginBottom:10, color:'#888594'}}
                    >
                        © 2025. <b>Humanely Solution </b> <br />Powered by Hub9 Technologies
                    </p>
                </div>
            </section>
        </>
    );
}
